<template>
  <div class="accordion">
    <div class="accordion_titleContainer">
      <h6>{{ title }}</h6>
      <span @click="isExpanded = !isExpanded">
        <i
          :class="{
            'budicon-chevron-bottom': !isExpanded,
            'budicon-chevron-top': isExpanded,
          }"
        />
      </span>
    </div>
    <p v-if="isExpanded" class="mt-3">
      {{ content }}
    </p>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'Accordion',
  data() {
    return {
      isExpanded: false,
    };
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
  },
});
</script>

<style lang="scss" scoped>
.accordion {
  border-top: 1px solid $gray-200;
  border-bottom: 1px solid $gray-200;
  border-radius: $border-radius;
  padding: 1rem;
  cursor: pointer;
}
.accordion_titleContainer {
  display: flex;
  align-items: center;
  min-width: 100%;
  justify-content: space-between;
}
.accordion_titleContainer i {
  font-size: 1.2rem;
}

@media (min-width: 500px) {
  .accordion {
    border: 1px solid $gray-200;
    border-radius: $border-radius;
    padding: 1rem;
    cursor: pointer;
  }
  .accordion_titleContainer {
    display: flex;
    align-items: center;
    min-width: 100%;
    justify-content: space-between;
  }
  .accordion_titleContainer i {
    font-size: 1.2rem;
  }
}
</style>
